<!-- <div>
<i nz-icon nzType="folder" nzTheme="twotone" class="header-icon"></i>&nbsp;<b
class="header-label">Setup-Profile</b>
</div> -->
<pg-header
  title="Setup-Profile"
  ticon="folder"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  @if ((USER_PERMISSIONS.slct_in==1)?true:false) {
  <div nz-row class="gridTop">
    @if (loader) {
    <ds-loading></ds-loading>
    }
    <div class="ds-card grid">
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="grdLst"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
        exportFileName="Designations List"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          type="buttons"
          [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="onEdit2(data)">Edit</div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
    <!-- <div *ngIf="(USER_PERMISSIONS.slct_in==1)?false:true" class="permMsg">{{mainMessage}}</div> -->
  </div>
  }
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="heading"
    (nzOnClose)="closeSideBar()"
  >
    <form nz-form [formGroup]="setupPrflForm">
      <div class="input-row" nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
          <div class="inptLbl">Enter Profile Name</div>
          <input type="text" nz-input formControlName="prfle_nm" />
        </div>
      </div>
    </form>
    <div class="ds-card grid">
      <div class="stpoptsmainhng">Setup Options</div>
      <ul class="stpopts" nz-list [nzDataSource]="stpGrpOptnLst" nzBordered>
        @for (g of stpGrpOptnLst; track g) {
        <div>
          <nz-list-header class="stpopthdr">{{ g.stp_grp_nm }}</nz-list-header>
          @for (item of g.setupitemList; track item) {
          <li nz-list-item nzNoFlex>
            <!-- <ul nz-list-item-actions>
                  <nz-list-item-action>
                    <label nz-checkbox [(ngModel)]="item.isActive" (ngModelChange)="ischeked($event,item)"></label>
                  </nz-list-item-action>
                </ul> -->
            <div class="input-row" nz-row>
              <div nz-col nzXs="22" nzSm="22" nzMd="22" nzLg="22" nzXl="22">
                {{ item.stp_opt_nm }}
              </div>
              <div nz-col nzXs="2" nzSm="2" nzMd="2" nzLg="2" nzXl="2">
                <label
                  nz-checkbox
                  [(ngModel)]="item.isActive"
                  (ngModelChange)="ischeked($event, item)"
                ></label>
              </div>
            </div>
            <!-- </div> -->
          </li>
          }
        </div>
        }
      </ul>
    </div>
    @if (editClicked==false && deleteClicked==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="sveSetupPrfl()">
      Submit
    </button>
    } @if (editClicked==true && deleteClicked==false) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      (click)="updtSetupPrfl()"
    >
      Update
    </button>
    } @if (editClicked==false && deleteClicked==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure deleting this profile?"
      [nzIcon]="iconTpl"
      nzPopconfirmPlacement="left"
      [nzPopconfirmShowArrow]="false"
      (nzOnConfirm)="delSetupPrfl()"
      nzOkType="danger"
      nzOkText="YES"
      nzCancelText="NO"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    }
    <button nz-button nzType="default" class="cnclBtn" (click)="cancelbtn()">
      Cancel
    </button>
    <ng-template #iconTpl>
      <i nz-icon nzType="question-circle-o" style="color: red"></i>
    </ng-template>
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
